import { Plus } from "lucide-react";

export const EmptyState = ({ text, actionLabel, onAction, testid, compact = false }) => (
  <div
    data-testid={testid}
    className={`flex flex-col items-center justify-center gap-2 text-center rounded-md border border-dashed border-white/15 ${compact ? "p-4" : "p-6"}`}
  >
    <div className="text-xs text-white/50">{text}</div>
    {onAction && (
      <button
        type="button"
        onClick={onAction}
        data-testid={testid ? `${testid}-action` : undefined}
        className="inline-flex items-center gap-1 h-7 px-2.5 rounded-md text-xs font-medium text-[#E11D2E] hover:bg-[#E11D2E]/10 transition-colors"
      >
        <Plus size={13} /> {actionLabel}
      </button>
    )}
  </div>
);
